import { useCallback, useState } from 'react';
import {
  EventDetail,
  MarketDayEventEnum,
  UseMarketDayMilestonesTrackingListenersProps
} from 'utils/marketDayMilestonesTracking/marketDayMilestonesTrackingUtils';
import useEventListener from 'utils/events/useEventListener';
const {
  MARKET_DAY_SECOND_CHANGED,
  MARKET_DAY_HALF_MINUTE_CHANGED,
  MARKET_DAY_MINUTE_CHANGED,
  MARKET_DAY_PERIOD_CHANGED,
  MARKET_DAY_HOUR_CHANGED,
  MARKET_DAY_CHANGED
} = MarketDayEventEnum;

// ==============================|| HOOK ||============================== //

export const useMarketDayMilestonesTrackingListener = ({
  onSecondChanged,
  onHalfMinuteChanged,
  onMinuteChanged,
  onPeriodChanged,
  onHourChanged,
  onDayChanged,
  onInitializeListener
}: UseMarketDayMilestonesTrackingListenersProps) => {
  const [isInitialized, setIsInitialized] = useState(false);

  const handleCustomEvent = useCallback(
    (event: CustomEvent<EventDetail>) => {
      switch (event.type) {
        case MARKET_DAY_SECOND_CHANGED:
          if (!isInitialized && onInitializeListener) {
            setIsInitialized(true);
            onInitializeListener(event.detail);
          }

          onSecondChanged && onSecondChanged(event.detail);
          break;
        case MARKET_DAY_HALF_MINUTE_CHANGED:
          onHalfMinuteChanged && onHalfMinuteChanged(event.detail);
          break;
        case MARKET_DAY_MINUTE_CHANGED:
          onMinuteChanged && onMinuteChanged(event.detail);
          break;
        case MARKET_DAY_PERIOD_CHANGED:
          onPeriodChanged && onPeriodChanged(event.detail);
          break;
        case MARKET_DAY_HOUR_CHANGED:
          onHourChanged && onHourChanged(event.detail);
          break;
        case MARKET_DAY_CHANGED:
          onDayChanged && onDayChanged(event.detail);
          break;
        default:
      }
    },
    [
      isInitialized,
      onDayChanged,
      onHalfMinuteChanged,
      onHourChanged,
      onInitializeListener,
      onMinuteChanged,
      onPeriodChanged,
      onSecondChanged
    ]
  );

  useEventListener(
    [
      MARKET_DAY_SECOND_CHANGED,
      MARKET_DAY_HALF_MINUTE_CHANGED,
      MARKET_DAY_MINUTE_CHANGED,
      MARKET_DAY_PERIOD_CHANGED,
      MARKET_DAY_HOUR_CHANGED,
      MARKET_DAY_CHANGED
    ],
    handleCustomEvent
  );
};
